import React, { useContext, useEffect, useState } from "react";
import supabase from "../supabase/supabaseClient";
import { DataContext } from "../context/DataContext";
import { Link } from "react-router-dom";
import estilo from "./styles/Contactos.module.css";

function Contactos() {
  const { usuario, url } = useContext(DataContext);

  const [datosUsuario, setDatosUsuario] = useState();
  const [lista, setLista] = useState([]);
  const [listaContactos, setListaContactos] = useState([]);
  const [cargando, setCargando] = useState(false);

  //datos del usuario
  useEffect(() => {
    const fetchUsuario = async () => {
      const { data, error } = await supabase
        .from("usuarios_chat")
        .select()
        .filter("user_id", "eq", usuario.id)
        .single();

      if (data) {
        setDatosUsuario(data);
      }
    };

    fetchUsuario();

    // Actualizar la lista de usuarios cada 10 segundos
    const interval = setInterval(() => {
      fetchUsuario();
    }, 5000);

    // Limpiar el intervalo cuando el componente se desmonta
    return () => clearInterval(interval);
  }, []);

  //carga
  useEffect(() => {
    setTimeout(() => {
      setCargando(true);
    }, 500);
  }, []);

  //datos de todos los usuarios
  useEffect(() => {
    const fetchContactos = async () => {
      const { data, error } = await supabase.from("usuarios_chat").select();

      if (data) {
        setLista(data);
      }
    };

    fetchContactos();
  }, [datosUsuario]);

  //obtenemos contactos que se tienen agregados
  useEffect(() => {
    const obtenerContactosComunes = () => {
      if (lista && datosUsuario) {
        const userContactoId = datosUsuario.user_id;
        const contactosComunes = lista.filter(
          (e) =>
            e &&
            e.contactos &&
            e.contactos.some(
              (contacto) =>
                contacto.contacto_id === userContactoId &&
                datosUsuario &&
                datosUsuario.contactos &&
                datosUsuario.contactos.some(
                  (userContacto) => userContacto.contacto_id === e.user_id
                )
            )
        );

        // Ordenar la lista de contactos comunes según el estado
        contactosComunes.sort((a, b) => {
          if (a.estado && !b.estado) {
            return -1; // a debe estar antes que b
          } else if (!a.estado && b.estado) {
            return 1; // a debe estar después de b
          } else {
            return 0; // no hay diferencia en el orden
          }
        });

        setListaContactos(contactosComunes);
      }
    };

    obtenerContactosComunes();
  }, [lista, datosUsuario]);

  return (
    <div className={estilo.contactos}>
      {cargando ? (
        listaContactos.length > 0 ? (
          listaContactos.map((e) => (
            <Link key={e.id} to={"/" + e.user_id}>
              <div className={estilo.lista}>
                <div className={estilo.perfil}>
                  <div className={estilo.foto}>
                    <img
                      src={url + e.user_id}
                      alt={e.nombre_usuario}
                      width="100px"
                      height="100px"
                    />
                  </div>

                  <p>{e.nombre_usuario}</p>
                </div>

                <div className={estilo.estado}>
                  {e.estado ? (
                    <span className={estilo.conectado}></span>
                  ) : (
                    <span className={estilo.no_conectado}></span>
                  )}
                </div>
              </div>
            </Link>
          ))
        ) : (
          <div className={estilo.sin_contactos}>
            <p>No tienes ningun Match</p>
          </div>
        )
      ) : null}

      {/* {listaContactos &&
        listaContactos.map((e) => (
          <Link key={e.id} to={"/" + e.user_id}>
            <div className={estilo.lista}>
              <div className={estilo.perfil}>
                <div className={estilo.foto}>
                  <img
                    src={url + e.user_id}
                    alt={e.nombre_usuario}
                    width="100px"
                    height="100px"
                  />
                </div>

                <p>{e.nombre_usuario}</p>
              </div>

              <div className={estilo.estado}>
                {e.estado ? (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className={estilo.conectado}
                  >
                    <path d="M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm-1 12.414-3.707-3.707 1.414-1.414L11 11.586l4.793-4.793 1.414 1.414L11 14.414z"></path>
                  </svg>
                ) : (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className={estilo.no_conectado}
                  >
                    <path d="M12 2C6.486 2 2 5.589 2 10c0 2.907 1.897 5.515 5 6.934V22l5.34-4.005C17.697 17.853 22 14.32 22 10c0-4.411-4.486-8-10-8zm-1 12.414-3.707-3.707 1.414-1.414L11 11.586l4.793-4.793 1.414 1.414L11 14.414z"></path>
                  </svg>
                )}
              </div>
            </div>
          </Link>
        ))} */}
    </div>
  );
}

export default Contactos;
